import React, { FC } from 'react';
import {
  TouchableOpacityProps,
  useWindowDimensions,
  View,
  ViewStyle,
} from 'react-native';
import ToastLib from 'react-native-toast-message';
import styled from 'styled-components/native';
import { palette } from '../../theme';
import NewButton from '../Button/NewButton';
import Text from '../Text';
export interface ToastProps extends TouchableOpacityProps {
  /**
   * The title of the toast.
   */
  title?: string;

  /**
   * The description of the toast.
   */
  description?: string;

  /**
   * An optional style override.
   */
  style?: ViewStyle | ViewStyle[];

  /**
   * One of the different types of presets.
   */
  preset?: ToastPresetNames;

  /**
   * flag to show or hide toast
   */
  visible?: boolean;

  /**
   * Position of Toast
   */
  position?: number;

  /**
   * Duration for toast to appear
   */
  duration?: number;

  /**
   * Callback for toast`s hide animation end
   */
  onHidden?: () => void;
}

export const Toast: FC<ToastProps> = (props) => {
  const { preset = 'success', title, description } = props;

  const { width } = useWindowDimensions();

  return (
    <Container
      style={[
        {
          backgroundColor: bg_colors[preset],
          maxWidth: Math.min(0.9 * width, 500),
          minWidth: Math.min(0.9 * width, 500),
        },
        props.style as never,
      ]}
    >
      <View style={[{ flex: 1 }]}>
        <Title weight="semibold">{title}</Title>
        {description ? <Description>{description}</Description> : null}
      </View>

      <View>
        <NewButton
          variant="text"
          iconColor="white"
          icon="times"
          onPress={ToastLib.hide}
        />
      </View>
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 12px;

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  min-height: 59px;
`;

const Title = styled(Text)`
  color: white;
`;

const Description = styled(Text)`
  color: white;

  margin-top: 8px;
`;

export type ToastPresetNames = 'success' | 'failure' | 'info';

const bg_colors: Record<ToastPresetNames, string> = {
  success: palette.success_60,
  failure: palette.Red,
  info: palette.secondary_700,
};
